var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getTargetOrigin } from "./config";
import { info } from "./utils/logging";
import { isValidIncomingTestBoxMessage, sendMessageToTestBox, } from "./messaging";
import { routeMessage } from "./router";
import { INITIALIZE_REQUEST } from "./messaging/outgoing";
let tbxStarted = false;
export let navigateHandler;
export let loginHandler = () => __awaiter(void 0, void 0, void 0, function* () { return false; });
export function startTestBox(config) {
    if (tbxStarted) {
        return;
    }
    window.__tbxConfig = config;
    if (window.__tbxConfig.navigateHandler) {
        navigateHandler = window.__tbxConfig.navigateHandler;
    }
    else {
        navigateHandler = (data) => {
            window.location.href = data.url;
        };
    }
    if (window.__tbxConfig.loginHandler) {
        loginHandler = window.__tbxConfig.loginHandler;
    }
    window.addEventListener("message", (ev) => {
        const targetOrigin = getTargetOrigin();
        if (!ev.origin.includes(targetOrigin)) {
            info("target-mismatch", {
                messageOrigin: ev.origin,
                targetOrigin: targetOrigin,
            });
            return;
        }
        const { data } = ev;
        if (!isValidIncomingTestBoxMessage(data)) {
            info("not-a-testbox-message", { data });
            return;
        }
        routeMessage(data, {
            navigate: navigateHandler,
            login: loginHandler,
        });
    });
    sendMessageToTestBox(INITIALIZE_REQUEST);
    tbxStarted = true;
}
export const start = startTestBox;
